import Movies from './[videoSlug]/[videoId]';
export default Movies;
